<template>
    <div class="d-flex align-items-center justify-content-center flex-wrap">  

      <!-- Skeleton -->
      <div class="d-flex align-items-center" style="min-height: 111px;" v-if="loadingSkeleton">
          <steps-bookings-skeleton v-for="(_, index) in cantidadStepsSkeleton" :key="index" :linea=" index == 2 ? false : true"/>
      </div>

      <!-- Steps bookings -->
      <div v-else v-for="(item, index) in menus" :key="index">
        <step-point-liquidaciones-extra-costos-component
          :text="item.nombre"
          :counter="item.cantidad"
          :first="index == 0 && true"
          :last="index == menus.length - 1 && true"
          :icon="item.icon"
          :size="28"
          :width="68"
          :urlActive="url_actual == item.url ? true : false"
          :url="item.url"
          :color="'#ed8026'"
          scale
        />
        
      </div>
    </div>
  </template>
  
  <script>

    import { mapState, mapActions } from "vuex";

    import StepsBookingsSkeleton from './skeletons/stepsBookingsSkeleton.vue';
    import StepPointLiquidacionesExtraCostosComponent from './StepPointLiquidacionesExtraCostosComponent.vue';
  
    //   import { getContadorBooking } from "../../constants/dashboard";
  
  export default {
    data() {
      return {
        menus: [
          {
              nombre : "Glosas",
              cantidad: 0,
              url : "/servicios_logisticos/liquidaciones_extra_costos/glosas",
              icon: "fas fa-file-alt"
          },
          {
              nombre : "Liquidaciones Preliminares",
              cantidad: 0,
              url : "/servicios_logisticos/liquidaciones_extra_costos/liquidaciones_preliminares",
              icon: "fas fa-file-invoice"
          },
          {
              nombre : "Liquidaciones Finales",
              cantidad: 0,
              url : "/servicios_logisticos/liquidaciones_extra_costos/liquidaciones_finales",
              icon: "fas fa-file-invoice-dollar"
          },
        ],
        cantidadStepsSkeleton : 3,
        loadingSkeleton: true
      };
    },
  
    computed: {
      ...mapState(["url_actual"]),
    },
  
    components: { 
        StepsBookingsSkeleton,
        StepPointLiquidacionesExtraCostosComponent 
    },
  
    methods: {
      ...mapActions("lineas", [
        "actionSetBookingContadoresClientes",
        "actionSetBookingContadoresUCC",
      ]),
  
      async recargarDataContadores() {

        // let data = await getContadorBooking();
  
        // this.bookingContadoresClientesAux = data[0];
  
        // setTimeout(() => {
        //   this.setMenuDependiendoRol();
        // }, 700);

      },
  
      async recargarDataContadoresLoop() {
        // let data = await getContadorBooking();
        // this.bookingContadoresClientesAux = data[0];
  
        setTimeout(() => {
          this.setMenuDependiendoRol();
        }, 700);
      },
    },

    mounted() {

      setTimeout(() => {

        this.menus[0].cantidad = 1;
        this.menus[1].cantidad = 2;
        this.menus[2].cantidad = 3;
        this.loadingSkeleton = false;
        
      }, 3000);
      
  
      //   this.recargarDataContadores();  

    },
  
    }
  </script>